/* eslint-disable react/jsx-key */
import clsx from 'clsx';

import styles from '../../styles.module.scss';
import ImageDesktop1 from '../images/chrome-desktop-1.png';
import ImageDesktop2 from '../images/chrome-desktop-2.png';
import ImageMobile1 from '../images/chrome-mobile-1.png';
import ImageMobile2 from '../images/chrome-mobile-2.png';
import ImageMobile3 from '../images/chrome-mobile-3.png';

export const listDesktop = [
    <div className={clsx(styles.contentDesktop, styles.center)}>
        Нажмите на&nbsp;значок c&nbsp;замком &nbsp;
        <img src={ImageDesktop1} alt='' />
        &nbsp; в&nbsp;адресной строке
    </div>,
    <>Перейдите в&nbsp;&laquo;Настройки сайтов&raquo;</>,
    <div className={clsx(styles.contentDesktop, styles.column)}>
        Разрешите доступ для микрофона&nbsp;/ камеры
        <img className={styles.image} src={ImageDesktop2} alt='' />
    </div>,
];

export const listMobile = [
    <div className={styles.contentMobile}>
        Нажмите на&nbsp;значок c&nbsp;замком
        <br />
        в&nbsp;адресной строке
        <img src={ImageMobile1} alt='' />
    </div>,
    <div className={styles.contentMobile}>
        Перейдите в&nbsp;раздел &laquo;Разрешения&raquo;
        <img src={ImageMobile2} alt='' />
    </div>,
    <div className={styles.contentMobile}>
        Разрешите доступ
        <br />
        для микрофона&nbsp;/ камеры
        <img src={ImageMobile3} alt='' />
    </div>,
];
